// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3-MbM","productName":"Table_productName__bIC3w"};